import { render, staticRenderFns } from "./replyDetailBox.vue?vue&type=template&id=56b71046&scoped=true"
import script from "./replyDetailBox.vue?vue&type=script&lang=js"
export * from "./replyDetailBox.vue?vue&type=script&lang=js"
import style0 from "./replyDetailBox.vue?vue&type=style&index=0&id=56b71046&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b71046",
  null
  
)

export default component.exports